import { render, staticRenderFns } from "./SpaceInvitations.vue?vue&type=template&id=aeb37bfa&scoped=true&"
import script from "./SpaceInvitations.vue?vue&type=script&lang=js&"
export * from "./SpaceInvitations.vue?vue&type=script&lang=js&"
import style0 from "./SpaceInvitations.vue?vue&type=style&index=0&id=aeb37bfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb37bfa",
  null
  
)

export default component.exports